import Image from "next/image";
import { useTranslation } from "next-i18next";
import { memo, useCallback } from "react";

import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
// import { useMousePosition } from "@hooks/useMousePosition";
import EmptySlider from "@components/cms/EmptySlider/EmptySlider";
import { useStore } from "@hooks/useZustandProvider";
import Editor from "@ui-kit/cms/Editor/Editor";
import Container from "@ui-kit/Container/Container";

import { collectionType, iconsData } from "./datas";
import s from "./TravelingBlock.module.scss";

const TravelingBlock = ({ settings, data, updateField }) => {
  const { t } = useTranslation();
  const { cms, updateCollectionType } = useStore();
  // const { isWidget } = useMousePosition();
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const { isEditMode } = cms.uiOptions;

  const { blockType } = settings.common;
  const {
    title,
    blockTitle1,
    blockContent1,
    blockTitle2,
    blockContent2,
    blockTitle3,
    blockContent3,
    blockTitle4,
    blockContent4,
    collections,
  } = data;
  const { items = [] } = collections?.[collectionType] || {};
  const cursorNotice = "Double click to edit features";

  const handleClickToEdit = useCallback((e) => {
    switch (e.detail) {
      case 2: // double click
        updateCollectionType(e);
    }
  }, []);

  return (
    <Container className={s.traveling}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <div className={s.info}>
            <div className={s.articles}>
              <article>
                <h5>
                  <Editor
                    field={{ blockTitle1 }}
                    onChange={updateField}
                    onlyText
                  />
                </h5>
                <Editor field={{ blockContent1 }} onChange={updateField} />
              </article>
              <article>
                <h5>
                  <Editor
                    field={{ blockTitle2 }}
                    onChange={updateField}
                    onlyText
                  />
                </h5>
                <Editor field={{ blockContent2 }} onChange={updateField} />
              </article>
              <article>
                <h5>
                  <Editor
                    field={{ blockTitle3 }}
                    onChange={updateField}
                    onlyText
                  />
                </h5>
                <Editor field={{ blockContent3 }} onChange={updateField} />
              </article>
              <article>
                <h5>
                  <Editor
                    field={{ blockTitle4 }}
                    onChange={updateField}
                    onlyText
                  />
                </h5>
                <Editor field={{ blockContent4 }} onChange={updateField} />
              </article>
            </div>
          </div>
          {items.length ? (
            <div
              className={s.features}
              {...(isEditMode && !(!isWidgetEditing && isWidget)
                ? {
                    "data-cursor-notice": cursorNotice,
                    "data-collection-type": collectionType,
                    onClick: handleClickToEdit,
                  }
                : {})}
            >
              {items.map((item) => {
                const icon = iconsData[item.title];
                return (
                  <div className={s.item} key={item.title}>
                    <div className={s.circle}>
                      <Image src={icon.src} alt={t(icon.label)} />
                    </div>
                    <span>{t(icon.label)}</span>
                  </div>
                );
              })}
            </div>
          ) : isEditMode ? (
            <EmptySlider
              cursorNotice={cursorNotice}
              collectionType={collectionType}
              onClick={handleClickToEdit}
            />
          ) : null}
        </section>
      </Container>
    </Container>
  );
};

export default memo(TravelingBlock);
